import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useField } from "formik";
import { Box, Dialog, FormControl, Typography } from "@mui/material";
import { FieldError } from "../FieldError/FieldError";
import { IconPerson } from "../../../utils/icons";
import { Button } from "../../Button/Button";

export function FieldImageUpload({ name, label, onChange, ...rest }) {
  const [field, meta, helpers] = useField(name);
  const [imgCropOpen, setImgCropOpen] = useState(false);
  const [img, setImg] = useState(field.value);

  const handleAvatarClick = () => {
    document.getElementsByName(field.name)[0].click();
  };

  useEffect(() => {
    if (field.value) setImg(field.value);
  }, [field]);
  
  const imageChange = (event) => {
    const { files } = event.target;
    if (files.length > 0) {
      const target = files[0];
      if (target.size < 15000000) {
        const fReader = new FileReader();
        fReader.readAsDataURL(target);
        fReader.onloadend = function (e) {
          const imageData = {
            source: e.target.result,
            file: target,
            extension: target.type.replace("image/", ""),
          };
          
          setImg(e.target.result);
          helpers.setValue(e.target.result);          
          if (onChange) {
            onChange(imageData);
          }
        };
      } else {
        toast.error("File exceeds maximum upload size.");
      }
    }
  };

  return (
    <FormControl className="flex flex-col gap-2">
      {label && (
        <Typography variant="body1" color="var(--text)">
          {label} <span className="text-xs ">( min size: 600x600px | .jpeg /.png )</span>
        </Typography>
      )}
      <input
        type="file"
        accept="image/*"
        name={field.name}
        onChange={imageChange}
        style={{ display: "none" }}
      />
      <Box className="flex gap-6 items-center">
        <Box className="h-[124px] w-[124px] cursor-pointer rounded-xl flex items-center justify-center bg-tint">
          {img ? (
            <img
              src={img}
              alt="pro headshot"
              className="w-full h-full rounded-xl object-cover object-top"
            />
          ) : (
            <IconPerson />
          )}
        </Box>
        <Box>
          <Button size="sm" onClick={handleAvatarClick}>Upload Image</Button>
        </Box>
      </Box>

      <Dialog
        open={imgCropOpen}
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={() => setImgCropOpen(false)}
      >
        <div>user image</div>
      </Dialog>
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  );
}
